

"use client";

import React from "react";
import { PrimaryButton } from "@/components/ui/primary-button";
import Image from "next/image";
import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import { capturePH } from "@/instrumentation-client";




export default function CallToAction() {
    const t = useTranslations('home.agent.cta');

    return (
        <section className="undetectable relative z-10 overflow-hidden pt-[62px] md:pt-[152px] lg:pt-[200px] xl:pt-[217px] bg-[#DDE2EE]">
            <div className="pointer-events-none absolute inset-x-0 z-0 w-full bg-[linear-gradient(180deg,#FFFFFF_0%,#DDE2EE_100%)] top-0 md:h-[152px] lg:h-[200px] xl:h-[217px] h-[62px]" ></div>
            <div className="mx-auto px-5 md:max-w-[768px] md:px-8 lg:max-w-[1024px] xl:max-w-[1280px] xl:px-8 2xl:max-w-[1408px]">
                <div className="w-full">
                    <div className="relative z-[1] flex flex-col gap-10 py-15 lg:gap-0 lg:pb-40 lg:pt-0">
                        {/* <svg width="100%" height="100%" className="text-muted-strong-background h-40 max-lg:hidden mask-b-from-30%">
                            <defs>
                                <pattern id="_R_tav9f9cdb_" width="10" height="10" patternUnits="userSpaceOnUse">
                                    <rect x="5.5" y="5.5" width="1" height="1" fill="currentColor"></rect>
                                </pattern>
                                </defs>
                                <rect width="100%" height="100%" fill="url(#_R_tav9f9cdb_)"></rect>
                        </svg> */}
                        <div className="relative z-[2] flex w-full flex-col justify-center overflow-visible">
                            <div className="relative z-[2] w-full flex items-center justify-center gap-0 sm:gap-4 md:gap-8 min-h-[100px] sm:min-h-[380px] md:min-h-[420px] lg:min-h-[360px]">
                                {/* <div className="pointer-events-none absolute inset-0">
                                    <div className="absolute left-1/2 top-1/2 size-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/40 blur-3xl"></div>
                                </div> */}
                                <motion.div
                                    initial={{ x: -40, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    viewport={{ once: true, amount: 0 }}
                                    transition={{ type: "spring", stiffness: 60, damping: 26, mass: 1.2 }}
                                    className="select-none pointer-events-none w-[48%] sm:w-[44%] md:w-[38%] max-w-[420px] shrink-0"
                                >
                                    <Image
                                        src="/funnel/adan-hand.avif"
                                        alt="Left hand"
                                        width={900}
                                        height={600}
                                        sizes="(max-width: 639px) 48vw, (max-width: 767px) 44vw, 38vw"
                                        draggable={false}
                                        className="w-full h-auto"
                                    />
                                </motion.div>
                                <motion.div
                                    initial={{ x: 40, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    viewport={{ once: true, amount: 0 }}
                                    transition={{ type: "spring", stiffness: 60, damping: 26, mass: 1.2 }}
                                    className="select-none pointer-events-none w-[48%] sm:w-[44%] md:w-[38%] max-w-[600px] shrink-0"
                                >
                                    <Image
                                        src="/funnel/ai-hand.avif"
                                        alt="Right hand"
                                        width={1000}
                                        height={650}
                                        sizes="(max-width: 639px) 48vw, (max-width: 767px) 44vw, 38vw"
                                        draggable={false}
                                        className="w-full h-auto"
                                    />
                                </motion.div>
                            </div>
                            {/* <div className="bg-[linear-gradient(to_right,white,transparent_20%,transparent_80%,white_100%)] pointer-events-none absolute inset-0 z-0 max-lg:hidden"> */}
                            <div className="pointer-events-none absolute inset-0 z-0 max-lg:hidden">
                            </div>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <h2 className="text-center text-heading-md">
                                <span className="block overflow-hidden">
                                    <span className="inline text-[20px] leading-tight font-medium -tracking-[0.04em] text-foreground sm:block sm:text-[28px] md:text-[24px] lg:text-[28px]">
                                        {t('headline.prefix')}
                                    </span>
                                </span>
                                <span className="block overflow-hidden text-heading-md-serif">
                                    <span className="text-transparent bg-clip-text w-fit block pb-0.inline gradient-text bg-[linear-gradient(96.56deg,_#667799_21.01%,#94A0B8_34.62%,#667799_47.64%,#667799_69.29%,#94A0B8_79.76%,#667799_90.35%)] text-[20px] leading-tight font-medium -tracking-[0.04em] sm:block sm:text-[28px] md:text-[24px] lg:text-[28px] transition-transform delay-750 duration-600 ease-[cubic-bezier(0.22,1,0.36,1)]">
                                    {t('headline.suffix')}
                                    </span>
                                </span>
                            </h2>
                            <div className="flex items-center justify-center gap-y-2 max-md:flex-col max-md:items-center mt-10 w-full gap-x-2 transition-opacity delay-1000 duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] opacity-100">
                            <PrimaryButton variant="dark" onClick={() => { try { capturePH('book_demo_clicked', { location: 'cta' }) } catch {}; window.open('/demo', '_self') }}><span className="whitespace-nowrap">{t('getStarted')}</span></PrimaryButton>
                                {/* <button className="relative inline-flex cursor-pointer items-center justify-center text-nowrap border transition-colors duration-400 ease-in-out hover:duration-150 active:duration-50 disabled:pointer-events-none disabled:cursor-default button-outline h-9 gap-x-1.5 rounded-[10px] px-3 text-sm has-[&gt;svg:last-child,&gt;img:last-child]:pr-2 has-[&gt;svg:first-child,&gt;img:first-child]:pl-2 max-lg:h-11.5 max-lg:gap-x-2 max-lg:rounded-xl max-lg:px-3.5 max-lg:text-base max-lg:has-[&gt;svg:last-child,&gt;img:last-child]:pr-3 max-lg:has-[&gt;svg:first-child,&gt;img:first-child]:pl-3 max-md:hidden">
                                    Talk to sales
                                </button> */}
                                <PrimaryButton variant="glass" onClick={() => { try { capturePH('book_demo_clicked', { location: 'cta_secondary' }) } catch {}; window.open(t('bookDemoLink'), '_self') }}><span className="whitespace-nowrap">{t('talkToSales')}</span></PrimaryButton>
                                {/* <button className="relative inline-flex cursor-pointer items-center justify-center text-nowrap border transition-colors duration-400 ease-in-out hover:duration-150 active:duration-50 disabled:pointer-events-none disabled:cursor-default button-ghost h-9 gap-x-1.5 rounded-[10px] px-3 text-sm has-[&gt;svg:last-child,&gt;img:last-child]:pr-2 has-[&gt;svg:first-child,&gt;img:first-child]:pl-2 max-lg:h-11.5 max-lg:gap-x-2 max-lg:rounded-xl max-lg:px-3.5 max-lg:text-base max-lg:has-[&gt;svg:last-child,&gt;img:last-child]:pr-3 max-lg:has-[&gt;svg:first-child,&gt;img:first-child]:pl-3 group self-center md:hidden">
                                    <span>
                                        Talk to sales
                                    </span>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className="relative transition-[translate] duration-400 ease-in-out group-hover:translate-x-0.25 group-hover:duration-150 group-active:translate-x-0.25 group-active:duration-50">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.1" d="M2.25 7h9.5m0 0L8.357 3.5M11.75 7l-3.393 3.5">
                                    </path>
                                    </svg>
                                </button> */}

                                
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}